var Participate = {

  param: undefined,
  shopListCurPage: 1,
  shopListItemNum: 4,

  init: function () {
    this.getPram();
    this.defineParam();
    this.slide01();
    this.slide02();
    this.setShopList();
    // this.ClipboardSetData();
  },

  getPram: function() {
    this.param = location.search;
    if(this.param){
      this.param = this.param.split('?')[1].split('=')[1];
    }
  },

  defineParam: function() {
    if(this.param === '2'){
      this.firstClickTab();
    }
  },

  firstClickTab: function(){
    $('#tab-btn-2').trigger('click');
  },

  slide01: function() {
    $('.js-p-participate-download-slider-01').slick({
      dots: true,
      responsive:[{
        breakpoint: 769,
        settings: 'unslick'
      }]
    });
  },

  slide02: function() {
    $('.js-p-participate-download-slider-02').slick({
      dots: true
    });
  },

  modal: function(){
    var _$btn = $('.js-p-participate-list-modal-btn');
    var _src;
    var _this = this;
    _$btn.on('click',function(){
      _src = $(this).css('background-image').replace(/.+(http.*[jpeg|jpg|png|gif]).*/,'$1');
      $(_this.setModalTemp(_src)).appendTo('body').fadeIn(200,function(){
        $('body').css({'overflow':'hidden'});
        _this.closeModal();
      });
    });
  },

  setModalTemp: function(_src) {
    var modalTemp = '<div class="c-modal-overlay js-p-participate-modal-close-btn">' +
                      '<div class="c-modal-wrapper">' +
                        '<div class="c-modal-inner">' +
                          '<div class="c-modal-contents">' +
                            '<div class="p-participate-list-modal-inner">' +
                              '<a href="javascript:void(0)" id="js-p-participate-modal-close-btn" class="p-participate-modal-close-btn js-p-participate-modal-close-btn"><img src="/assets/img/common/btn_close.png"></a>' +
                              '<img src="'+ _src +'">' +
                            '</div>' +
                          '</div>' +
                        '</div>' +
                      '</div>' +
                    '</div>';
    return modalTemp;
  },

  closeModal: function(){
    var _$btn = $('.js-p-participate-modal-close-btn');
    _$btn.on('click',function(){
      $('.c-modal-overlay').fadeOut(200,function(){
        $(this).remove();
        $('body').css({'overflow':'auto'});
      });
    });
  },

  // 参加店舗一覧 生成
  setShopList: function(){
    var me = this,
        $shoplist = $('.js-shoplist');

    $shoplist.each(function(){
      var $parent = $(this);
      fetchShopData(me.shopListCurPage, me.shopListItemNum).done(function(data){
        if(data.status === 1){
          for(var i=0, l=data.results.length;i<l;i++){
            $parent.append(createItem(data.results[i]));
          }
          me.modal();
        }
      });
    });



    function createItem(data){
      var _pref = '〒' + data.postal_code_first + '-' + data.postal_code_second + '&nbsp;',
          _url = '<a class="p-participate-list-address-link" href="' + data.url + '" target="_blank">' + data.url + '<span class="p-participate-list-address-link-img"></span></a>',
          _img1 = data.shop_image_url,
          _img2 = data.donation_box_image_url;
          //_img1 = '<img href="' + data.shop_image_url + '" />',
          //_img2 = '<img href="' + data.donation_box_image_url + '" />';

      var item ='\
        <div class="p-participate-list-lyt-clm-01">\
          <div class="clm-01">\
            <p class="ttl">' + data.shop_name + '</p>\
            <p class="txt">' + data.word + '</p>\
            <dl class="address-holder">\
              <dt>住所</dt>\
              <dd>\
                ' + ( data.postal_code_first ? _pref : ' ' ) + '\
                ' + data.pref_name + '\
                ' + data.city + '\
                ' + data.address + '\
                ' + data.building + '\
              </dd>\
              <dt>電話番号</dt>\
              <dd>\
              ' + data.phone_number + '\
              </dd>\
              <dt>サイトURL</dt>\
              <dd>\
              ' + ( data.url ? _url : ' ' ) + '\
              </dd>\
            </dl>\
          </div>\
          <div class="clm-02">\
            <div class="left-clm">\
              <div class="clm-inner">\
                <a class="left-img js-p-participate-list-modal-btn" href="javascript:void(0)" style="background-image: url(\
                ' + ( data.shop_image_url ? _img1 : '/assets/img/participate/list/bg_dummy.png' ) + '\
                )">\
                </a>\
              </div>\
            </div>\
            <div class="right-clm">\
              <div class="clm-inner">\
                <a class="right-img js-p-participate-list-modal-btn" href="javascript:void(0)" style="background-image: url(\
                ' + ( data.donation_box_image_url ? _img2 : '/assets/img/participate/list/bg_dummy.png' ) + '\
                )">\
                </a>\
              </div>\
            </div>\
          </div>\
        </div>\
      ';

      return item;
    }
  }
};


/** ショップデータ取得
 * @param {int} offset - 取得し始めたい位置 1以上の整数のみ受け付ける
 * @param {int} limit - 取得したい件数 1以上の整数のみ受け付ける
 */
function fetchShopData(offset, limit){
  var deferred = $.Deferred();
  $.ajax({
    url: '/api/getCurrentShopList.php',
    type: 'POST',
    dataType: 'json',
    data: {
      //offset: offset,
      //limit: limit
    },
    success: deferred.resolve,
    error: deferred.reject
  });

  return deferred.promise();
}





module.exports = Participate;


//////////////////
// WEBPACK FOOTER
// ./htdocs_dev/_script/components/pagemodules/_participate.js
// module id = 11
// module chunks = 0